// react library imports
import { MagnifyingGlass } from "phosphor-react";

// import style 
import './Search.css';

// search list component 
const SearchList = ({results, loading, onChange}) =>{
    if(loading) return <div className='search_list_container mues_row_center'>Loading...</div>
    if(results?.length <=0) return <div className='search_list_container mues_row_center'><h3>No Data Found</h3></div>
    return(
    <div className='search_list_container'>
        {results?.map(item=>(
            <div className='search_list_card' key={item.id}
            onClick={()=>onChange(item)}>
                <p className='mues_grey_I mues_font_weight_600
                 mues_pointer'>{item.title}</p>
            </div>
        ))}
    </div>
    )
}

const Search = ({placeholder, id, query, onChange, list, loading, showList, onClick}) => {
    return (
        <div className="search_container mues_row_flex mues_column_gap_8" id={id}>
            <MagnifyingGlass className="mues_wrapper_icon mues_grey_I" weight="bold"/>
            <input type="text" placeholder={placeholder} value={query}
            onChange={e=>onChange(e)}/>
            {showList && <SearchList results={list} loading={loading}
            onChange={onClick}/>}
        </div>
    );
};
export default Search;
